import { render, staticRenderFns } from "./InterventionPage.vue?vue&type=template&id=05bd88a5"
import script from "./InterventionPage.vue?vue&type=script&lang=js"
export * from "./InterventionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports